<script setup lang="ts">
const { t } = useI18n({ useScope: "local" });

withDefaults(
  defineProps<{
    icon?: string;
    title?: string;
    hasQuery?: boolean;
    /** Au moins un filtre actif (catégorie/ville/prix/date). Active le
     *  bouton « Réinitialiser les filtres » noir rounded-full sous le
     *  texte. Karim 2026-06-25. */
    hasFilters?: boolean;
    emptyDescription?: string;
  }>(),
  {
    icon: "i-lucide-search",
  }
);

defineEmits<{
  reset: [];
}>();
</script>

<template>
  <div class="text-center py-24">
    <div class="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-4">
      <UIcon :name="icon" class="size-8 text-gray-400" />
    </div>
    <h3 class="text-lg font-bold text-gray-900 mb-1">{{ title ?? t('emptyState.titre') }}</h3>
    <p class="text-sm text-gray-500">
      {{ hasQuery || hasFilters ? t('emptyState.criteres') : (emptyDescription ?? t('emptyState.description')) }}
    </p>
    <button
      v-if="hasFilters || hasQuery"
      type="button"
      class="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-gray-900 text-white text-sm font-semibold hover:bg-gray-800 transition-colors"
      @click="$emit('reset')"
    >
      <UIcon name="i-lucide-rotate-ccw" class="size-4" />
      <span>{{ t('emptyState.reinitialiser') }}</span>
    </button>
  </div>
</template>

<i18n lang="json" src="../../../i18n/pages/components/recherche-page/RechercheEmptyState.json"></i18n>
